import { cx } from "@jugl-web/utils";
import { FC } from "react";
import { ReactComponent as JuglLogoIcon } from "./assets/jugl-logo.svg";

interface PoweredByJuglLabelProps {
  className?: string;
}

/**
 * Compact "Powered by Jugl" attribution linking to jugl.com.
 * Used on full-page feedback screens and chat footers.
 */
export const PoweredByJuglLabel: FC<PoweredByJuglLabelProps> = ({
  className,
}) => (
  <div
    className={cx("flex shrink-0 justify-center bg-white py-2.5", className)}
  >
    <a
      href="https://jugl.com"
      target="_blank"
      rel="noopener noreferrer"
      className={cx(
        "inline-flex items-center gap-[3px] text-grey-700 no-underline transition-colors hover:text-[#2F80ED]",
        "-mb-px border-t-0 border-r-0 border-b border-b-1 border-l-0 border-solid border-transparent hover:border-b-[#2F80ED]"
      )}
    >
      <span className="font-secondary text-xs leading-[1.5]">Powered by</span>
      <JuglLogoIcon />
    </a>
  </div>
);
